import React from 'react';
import { useLocation } from 'react-router-dom';

/**
    This functional component will use the `useLocation` hook
    and pass `location` as a prop to the class component 
**/
function withLocation(Component) {
    return function WrappedComponent(props) {
        const location = useLocation();
        return <Component {...props} location={location} />;
    };
}

export default withLocation;
